import {
  Menu,
  MenuHandler,
  MenuList,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MenuInfoAdmin from "./MenuInfo";
import * as notifyApi from "../../../service/notifyApi";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { CurrentUserContext } from "../../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

function MenuAdmin({ menuActive }) {
  const navigate = useNavigate();

  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const [notifyList, setNotifyList] = useState([]);
  const [page, setPage] = useState(1);
  const [getNotificationTotal, setGetNotificationTotal] = useState(
    localStorage.getItem("Notification"),
  );
  const [openModalApprove, setOpenModalApprove] = useState(false);
  const [itemOnClickNotify, setItemOnClickNotify] = useState("");
  const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
    localStorage.getItem("user"),
  );
  const [new_notify, setNew_nottify] = useState(false);

  const [open, setOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  // Call Scanner
  const [openModal, setOpenModal] = useState(false);
  const [status, setStatus] = useState("Disconnected");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [photo, setPhoto] = useState("");
  const [permissionAccess, setPermissionAccess] = useState(false);
  const [permissionSend, setPermissionSend] = useState(false);
  const [menu, setMenu] = useState("");

  useEffect(() => {
    if (localStorage.getItem("Notification") === null) {
      setGetNotificationTotal(0);
    } else {
      // console.log(getNotificationTotal);
    }
    getRequestPermission();
    setUserRole(user); //ใช้อัพเดท route path ทุกครั้งถ้ามีการ อัพเดท
  }, [checkUserAfterLogin]);

  const [widtht, setWidth] = useState(0);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      // console.log("updating Width");
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (widtht > 767) {
      setOpen(false);
    }
  }, [widtht]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        setNotifyList(res["data"]["notification_list"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
        setNew_nottify(res["data"]["is_new_badge"]);
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setReadNotification = async () => {
    setLoading(true);
    let res = await notifyApi.setReadNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res["data"]);
        getRequestPermission();
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <>
      <div style={styles.topBar}>
        <div
          style={
            menu === "contact"
              ? { ...styles.topLink, ...styles.topLinkHover }
              : styles.topLink
          }
          onClick={() => navigate("/contact")}
        >
          ติดต่อเรา
        </div>
        <div
          style={
            menu === "ansQandA"
              ? { ...styles.topLink, ...styles.topLinkHover }
              : styles.topLink
          }
          onClick={() => navigate("/ansQandA")}
        >
          คำถามที่พบบ่อย
        </div>
        <div
          style={
            menu === "questionnaire"
              ? { ...styles.topLink, ...styles.topLinkHover }
              : styles.topLink
          }
          onClick={() => navigate("/questionnaire")}
        >
          แบบประเมินความพึงพอใจ
        </div>
      </div>

      <nav className="bg-white z-10 fixed top-[30px] left-0 right-0 md:h-[70px] w-full shadow-xl rounded-b-3xl flex justify-between items-center">
        {/* logo&appname */}
        <div className="flex justify-center items-center">
          <button onClick={() => navigate("/admin")}>
            <img
              className="mr-5 ml-[50px] lg:ml-[30px] md:ml-[20px] sm:ml-0xsm:ml-0 lg:h-[50px] md:h-[20px] sm:h-[10px]"
              src={require("../../../asset/image/logo.svg").default}
              alt=""
            ></img>
          </button>
          <ul className="h-full flex items-center md:hidden">
            {/* หน้าหลัก */}
            <li>
              <button
                onClick={() => navigate("/admin")}
                className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${
                  menuActive === "homeadmin"
                    ? "text-[#FF9768] font-bold"
                    : "text-[#000000]"
                } hover:text-[#FF9768]`}
              >
                หน้าหลัก
              </button>
            </li>
            {/* จัดการผู้ใช้งาน */}
            <li>
              <button
                onClick={() => navigate("/admin/news")}
                className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${
                  menuActive === "news"
                    ? "text-[#FF9768] font-bold"
                    : "text-[#000000]"
                } hover:text-[#FF9768]`}
              >
                ประชาสัมพันธ์
              </button>
            </li>
            {/* จัดการข้อมูลเว็บไซต์ */}
            <li>
              <button
                onClick={() => navigate("/admin/about")}
                className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${
                  menuActive === "managewebsite"
                    ? "text-[#FF9768] font-bold"
                    : "text-[#000000]"
                } hover:text-[#FF9768]`}
              >
                เกี่ยวกับเรา
              </button>
            </li>
            {/* กรองข้อมูลแลป */}
            <li>
              <button
                onClick={() => navigate("/admin/information")}
                className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${
                  menuActive === "mangePetition"
                    ? "text-[#FF9768] font-bold"
                    : "text-[#000000]"
                } hover:text-[#FF9768]`}
              >
                ข้อมูลที่เกี่ยวข้อง
              </button>
            </li>
            {/* ตั้งค่าโรงพยาบาล */}
            <li>
              <button
                onClick={() => navigate("/admin/usermanagement")}
                className={`mr-5 xl:mr-2 text-lg xl:text-md lg:mr-1 lg:text-sm md:mr-0 md:text-xs ${
                  menuActive === "adminsetting"
                    ? "text-[#FF9768] font-bold"
                    : "text-[#000000]"
                } hover:text-[#FF9768]`}
              >
                สำหรับแอดมิน
              </button>
            </li>
          </ul>
        </div>

        {/* mobile */}
        <div className="flex justify-end items-center gap-10 invisible text-3xl absolute right-10 top-15 md:visible">
          <ul
            onClick={() => {
              if (new_notify) {
                setReadNotification();
              }
            }}
          >
            <Menu>
              <MenuHandler>
                <button
                  onClick={() => {}}
                  className="flex h-full outline-none items-center relative"
                >
                  <img
                    onClick={() => {
                      setOpen(false);
                    }}
                    className="w-[48px] h-[48px] rounded-full lg:w-[40px] lg:h-[40px]"
                    src="/notify.svg"
                    alt="notify"
                  />
                  {new_notify ? (
                    <>
                      <div
                        className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-3 lg:h-3 text-[0.60rem] leading-tight font-medium rounded-full flex items-center justify-center hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF] `}
                      ></div>
                    </>
                  ) : null}
                </button>
              </MenuHandler>
              <MenuList
                className={`flex flex-col ${
                  notifyList.length > 0 ? "mt-7 w-80 rounded-2xl" : "rounded-xl"
                } z-[19]`}
              >
                <div className="h-full">
                  <div
                    className={`${
                      notifyList.length > 3
                        ? "overflow-y-scroll"
                        : "overflow-hidden"
                    } `}
                  >
                    <div
                      className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                    >
                      {notifyList.length ? (
                        <>
                          {notifyList.map((i, idx) => (
                            <button
                              key={idx}
                              className="grid py-1 rounded-lg px-[15px] w-full"
                            >
                              <div
                                onClick={() => {}}
                                className="hover:rounded-lg hover:bg-[#fdf4f0] p-[5px]"
                              >
                                <div className="grid grid-cols-[auto_50px] justify-between font-bold py-[5px]">
                                  <div>{i["payload"]["topic"]}</div>
                                  <div className="text-[#FFC0A4]">
                                    {i["create_date"]["time"]}
                                  </div>
                                </div>
                                <div className="text-[#FF9768] flex justify-start py-[5px]">
                                  {i["payload"]["detail"]}
                                </div>
                                <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                              </div>
                            </button>
                          ))}
                        </>
                      ) : (
                        <div className="text-center text-[#2E2E2E] font-medium">
                          ไม่พบการแจ้งเตือน
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </MenuList>
            </Menu>
          </ul>
          <ul>
            <Menu open={open}>
              <MenuHandler>
                <div>
                  {open ? (
                    <XMarkIcon
                      onClick={() => setOpen(!open)}
                      className="w-6 stroke-[#FF9768] stroke-[3px]"
                    />
                  ) : (
                    <Bars3Icon
                      onClick={() => setOpen(!open)}
                      className="w-6 stroke-[#FF9768] stroke-[3px]"
                    />
                  )}
                </div>
              </MenuHandler>
              <MenuList className="flex flex-col items-center md:gap-y-3 gap-y-5 h-[440px] md:h-auto rounded-3xl">
                <div
                  onClick={() => navigate("/admin")}
                  className={`text-md ${
                    menuActive === "homeadmin"
                      ? "text-[#FF9768] font-bold"
                      : "text-[#000000]"
                  }`}
                >
                  หน้าหลัก
                </div>
                <div
                  onClick={() => navigate("/admin/usermanagement")}
                  className={`text-md ${
                    menuActive === "usermanagement"
                      ? "text-[#FF9768] font-bold"
                      : "text-[#000000]"
                  }`}
                >
                  จัดการผู้ใช้งาน
                </div>
                <div
                  onClick={() => navigate("/managewebsite")}
                  className={`text-md ${
                    menuActive === "managewebsite"
                      ? "text-[#FF9768] font-bold"
                      : "text-[#000000]"
                  }`}
                >
                  จัดการข้อมูลเว็บไซต์
                </div>
                <div
                  onClick={() => navigate("/mangePetition")}
                  className={`text-md ${
                    menuActive === "mangePetition"
                      ? "text-[#FF9768] font-bold"
                      : "text-[#000000]"
                  }`}
                >
                  กรองข้อมูลแลป
                </div>
                <div
                  onClick={() => navigate("/hospitalsetting")}
                  className={`text-md ${
                    menuActive === "hospitalsetting"
                      ? "text-[#FF9768] font-bold"
                      : "text-[#000000]"
                  }`}
                >
                  ตั้งค่าโรงพยาบาล
                </div>
                <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768]"></div>
                <div className="flex flex-col gap-3 justify-center items-center">
                  <img
                    className={
                      user?.profile_image
                        ? "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px] rounded-full"
                        : "w-[48px] h-[48px] lg:w-[30px] lg:h-[30px]"
                    }
                    src={
                      user?.profile_image
                        ? user?.profile_image
                        : require("../../../asset/icon/iconuser.svg").default
                    }
                    alt="iconuser"
                  />
                  <p className="text-[#FF9768] text-lg font-medium px-3 lg:text-xs">
                    {user?.fname + " " + user?.lname}
                  </p>
                </div>

                <div className="flex flex-col items-center gap-y-2 md:w-full">
                  <div
                    onClick={() => {
                      navigate("/admin/ManageInfo");
                    }}
                    className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                  >
                    จัดการข้อมูลส่วนตัว
                  </div>
                  {/* <div onClick={() => { navigate('/usermanagement') }} className="button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]">จัดการผู้ใช้งานอื่นๆ</div> */}
                  <div
                    onClick={() => {
                      navigate("/admin/changepassword");
                    }}
                    className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                  >
                    เปลี่ยนรหัสผ่าน
                  </div>
                  <div
                    onClick={() => {
                      navigate("/admin/about");
                    }}
                    className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                  >
                    เกี่ยวกับเรา
                  </div>
                  <div
                    onClick={() => {
                      navigate("/admin/ans");
                    }}
                    className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                  >
                    คำถามที่พบบ่อย
                  </div>
                  <div
                    onClick={() => {
                      navigate("/admin/contact");
                    }}
                    className="md:w-full text-center button-theme-pg bg-[#FF9768] rounded-full text-white text-[10px]"
                  >
                    ติดต่อเรา
                  </div>
                </div>

                <div
                  onClick={() => {
                    localStorage.clear();
                    navigate("/login");
                  }}
                  className="flex justify-center items-center bg-white rounded-full w-[120px] md:w-full h-[25px] ring-1 ring-[#FF9768]"
                >
                  <img
                    src={require("../../../asset/icon/logout.svg").default}
                    alt=""
                    className="mr-2 w-[12px]"
                  />
                  <p className="text-[#FF9768] text-xs">ออกจากระบบ</p>
                </div>
              </MenuList>
            </Menu>
          </ul>
        </div>

        {/* web*/}
        <ul className="h-full flex items-center md:hidden">
          {/* หน้าหลัก */}
          {/* เเจ้งเตือน */}
          <li
            onClick={() => {
              if (new_notify) {
                setReadNotification();
              }
            }}
          >
            <Menu>
              <MenuHandler>
                <button
                  onClick={() => {}}
                  className="flex h-full outline-none items-center mr-3 relative"
                >
                  <FontAwesomeIcon
                    icon={faBell}
                    alt="notify"
                    className="w-[16px] h-[18px] rounded-full lg:w-[28px] lg:h-[28px]"
                  />
                  {/* <img
                  className="w-[48px] h-[48px] rounded-full lg:w-[30px] lg:h-[30px]"
                  src="/notify.svg"
                  alt="notify"
                /> */}
                  {new_notify ? (
                    <>
                      <div
                        className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-3 lg:h-3 text-[0.65rem] leading-tight font-medium rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF]`}
                      ></div>
                    </>
                  ) : null}
                </button>
              </MenuHandler>
              <MenuList
                className={`flex flex-col ${
                  notifyList.length > 0 ? "mt-7 w-80 rounded-2xl" : "rounded-xl"
                } z-[19]`}
              >
                {/* <div className='hover:cursor-pointer'>
                                    <div className='flex justify-center items-center gap-5'>
                                        <img className='w-10' src={require('../../../asset/icon/iconuser.svg').default} alt='' />
                                        <div className='text-[#2E2E2E] font-medium'>นาย กกกกก ขขขขขขข</div>
                                        <div className='text-[#FFC0A4]'>เวลา</div>

                                    </div>
                                    <div className='flex justify-center items-center gap-5'>
                                        <div className='text-[#FF9768]'>{'รายละเอียดแจ้งเตือน...'}</div>
                                        <div className=''>{'icon'}</div>
                                    </div>
                                </div> */}
                <div className="h-full">
                  <div
                    className={`${
                      notifyList.length > 3
                        ? "overflow-y-scroll"
                        : "overflow-hidden"
                    } `}
                  >
                    <div
                      className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                    >
                      {notifyList.length ? (
                        <>
                          {notifyList.map((i, idx) => (
                            <button
                              key={idx}
                              className="grid py-1 rounded-lg px-[15px] w-full"
                            >
                              <div
                                onClick={() => {}}
                                className="hover:rounded-lg hover:bg-[#fdf4f0] p-[5px]"
                              >
                                <div className="grid grid-cols-[auto_50px] justify-between font-bold py-[5px]">
                                  <div>{i["payload"]["topic"]}</div>
                                  <div className="text-[#FFC0A4]">
                                    {i["create_date"]["time"]}
                                  </div>
                                </div>
                                <div className="text-[#FF9768] flex justify-start py-[5px]">
                                  {i["payload"]["detail"]}
                                </div>
                                <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                              </div>
                            </button>
                          ))}
                        </>
                      ) : (
                        <div className="text-center text-[#2E2E2E] font-medium">
                          ไม่พบการแจ้งเตือน
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </MenuList>
            </Menu>
          </li>
          {/* ข้อมูลส่วนตัว */}
          <li className="h-[87px]">
            <MenuInfoAdmin />
          </li>
        </ul>
      </nav>
    </>
  );
}

export default MenuAdmin;

const styles = {
  topBar: {
    zIndex: 5,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "flex-end",
    backgroundColor: "#4F9C9D",
    fontSize: "16px",
    padding: "5px 50px",
    gap: "30px",
    color: "white",
  },
  topLink: {
    cursor: "pointer",
    transition: "color 0.3s ease",
    fontSize: "16px",
  },
  topLinkHover: {
    textDecoration: "underline",
  },
};
